import type { ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import { useId } from "../lib/uid.ts";
import { DiscloseIcon } from "./icons.tsx";
import { inlineButtonClass } from "./styles.ts";

/** A region shown or hidden by a small toggle: a chevron (right, turning down when open) and its summary. */
export function Disclosure(p: { summary: ComponentChildren; open?: boolean; children: ComponentChildren }) {
  const [open, setOpen] = useState(p.open ?? false);
  const id = useId();
  return (
    <div>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
        class={`${inlineButtonClass("muted", "xs")} -ml-1 h-7 px-1`}
      >
        <DiscloseIcon size={14} class={`transition-transform ${open ? "rotate-90" : ""}`} />
        {p.summary}
      </button>
      <div id={id} hidden={!open}>
        {p.children}
      </div>
    </div>
  );
}
